import { Component, OnInit, OnDestroy, HostListener, AfterViewInit } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import 'hammerjs';
import * as $ from 'jquery';
import * as slick from 'ngx-slick';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss'],
})

export class TeamComponent implements OnInit, OnDestroy, AfterViewInit {

  private fragment: string;
  isMobile: boolean;

  startHeight: any;
  expandHeight: any;

  // --> TEAM MEMBERS
  teamMembers = [
    {
      id: 0,
      pId: 'p0',
      imgId: 'img0',
      textId: 'txt0',
      name: 'DAVID KOHLER',
      role: 'Chief Executive Officer',
      linked: 'https://www.linkedin.com/in/dave-kohler-a7b6664/',
      email: 'dkohler@mimisrock.com',
      image: "url('./assets/images/team/david1200x800.png')",
      isLeft: false,
      isOpen: false,
      description: 'I may be the luckiest guy I know. Great Family – check. Great Team at work – check. Great friend network – check.',
      description2: 'Now, following a long run with a leading pharmaceutical company, I’ve moved into the dietary supplement business. I have the privilege of leading a group of passionate individuals looking to make a difference in the Health and Wellness space. I’m impressed daily by their creativity and energy. And when I’m not having fun at work, you can find me chasing one of my many, disparate interests. I also love to be active. Golf, hiking, cycling, running, the gym or just hanging out outdoors. So give me a call if you want to discuss any of these areas, but WARNING: if you’re a Dallas Cowboys or Montreal Canadiens fan, I may not pick up your call!',
      description3: ''
    },
    {
      id: 1,
      pId: 'p1',
      imgId: 'img1',
      textId: 'txt1',
      name: 'TELFER HANSON',
      role: 'Executive Chairman',
      linked: ' https://www.linkedin.com/in/telfer-hanson-9a278218/',
      email: 'thanson@mimisrock.com',
      image: "url('./assets/images/team/telfer1200x800.png')",
      isLeft: true,
      isOpen: false,
      description: 'The year was 1967 and 4-year-old me walking through the Toronto Maple Leafs dressing room, with a program in each hand, signed by every player on the Stanley Cup winning team. I knew I had just won the lottery. Born and raised in Moore Park Toronto, I lived in the city for the first 25 years of my life. You can catch me any day of the week watching endless hours of CNN – I am a news junkie (so my wife says). With 30 years in the investment banking world, the majority were spent in the medical device industry. I have a love for travel. During the winter months you will very easily find my wife and I lying on a beach, Kobos in hand, enjoying the sun. Reach out whenever you want to chat about sports, travel, or anything around the world as I consider myself a beacon of knowledge – or as I say - I know a whole lot about a whole little.',
      description2: '',
      description3:  ''
    },
    {
      id: 2,
      pId: 'p2',
      imgId: 'img2',
      textId: 'txt2',
      name: 'ANDREW PATIENT',
      role: 'Chief Financial Officer',
      linked: ' https://www.linkedin.com/in/andrew-patient-cpa-ca-44665212b/',
      email: 'apatient@mimisrock.com',
      image: "url('./assets/images/team/andrew1200x800.png')",
      isLeft: false,
      isOpen: false,
      description: 'Raised in England, via Mississauga, and a five-year stint in San Diego, I now live in Oakville with my two kids, wife, and dog.  As a Londoner in my youth, I grew to love the beautiful game and still holding on as a player, I am hopeful any of my teams (Arsenal, Bills and Raptors) will finally win one.  Love to talk obscure sports trivia or engage in heated debates on meaningless topics. Happiest on the pitch, I also have a soft spot for wine gums or a good burrito. Philosophically, I am a big believer in karma – you reap what you sow – and so…you do what you can to make the world a better place.',
      description2: '',
      description3:  ''
    },
    {
      id: 3,
      pId: 'p3',
      imgId: 'img3',
      textId: 'txt3',
      name: 'CHIRAG PATEL',
      role: 'Vice President, Operations & Corporate Strategy',
      linked: ' https://www.linkedin.com/in/chirag-patel-mba-06527a20',
      email: 'cpatel@mimisrock.com',
      image: "url('./assets/images/team/chirag1200x800.png')",
      isLeft: true,
      isOpen: false,
      description: 'As a lifelong Toronto sports fan, I’ve spent most of my life suffering. 1967 was well before my time and celebrating in my parent’s basement in 92/93 wasn’t that exciting. The good news is, “this is the year”, right? I once told my wife I would disappear for 2 weeks if the Maple Leafs ever won the Stanley Cup, but now I’m not so sure that would fly. Along our journey together, we ended up with 2 awesome kids. As great as they are, most times they make me want to pull out all of my hair. Lucky for me, I don’t have any and I like it this way. I really do.',
      description2: 'I embrace change, love new challenges, and am passionate about growing new businesses. Feel free to drop me a line at any time. I’d love to hear from you.',
      description3:  ''
    },
    {
      id: 4,
      pId: 'p4',
      imgId: 'img4',
      textId: 'txt4',
      name: 'RYAN MALFARA',
      role: 'Managing Director, DTI GmbH',
      linked: 'https://www.linkedin.com/in/ryanmalfara',
      email: 'rmalfara@mimisrock.com',
      image: "url('./assets/images/team/ryan1200x800.png')",
      isLeft: false,
      isOpen: false,
      description: "Born and raised in the 6ix, I am a thoroughbred Torontonian. I love this city and know it like the back of my hand, especially the restaurants in it. ",
      description2: "I’ve been told I have the “Golden touch” when it comes to technology and I always seem to be the first call when technology goes down, my friends know they can count on me to get things back up and running in no time. My colleagues are quickly figuring this out too, I guess that’s why I look after technology for the company.  ",
      description3:  "I am confident that good conversation is started over a good charcuterie board and a nice bourbon. I have a great sense of humour, and love to laugh, however others don’t seem to respond the same to my jokes...🤷🏻‍♂️. If you really want to get me talking, just ask me about my 650km foot race to the North Pole."
    },
    {
      id: 5,
      pId: 'p5',
      imgId: 'img5',
      textId: 'txt5',
      name: 'CASSIE HANSON',
      role: 'Director, e-Commerce',
      linked: ' https://www.linkedin.com/in/cassandrahanson',
      email: 'chanson@mimisrock.com',
      image: "url('./assets/images/team/cassie1200x800.png')",
      isLeft: true,
      isOpen: false,
      description: 'Oakville, Victoria (BC), Exeter (England), and Toronto have all been places I’ve called home. Having visited 18 countries and counting, I truly believe that the only way to experience life is to immerse yourself in other communities. I believe Thai food and Netflix is the perfect way to spend a Friday night and that you cannot go wrong if peanut M&Ms are included. I love the sweet and salty mix of scrambled eggs and Jam. I consider giraffes to be the most majestic animals on the planet – they get to see the whole world from above. I am a huge sports fanatic – you’ll catch me in front of any hockey, football, or baseball game on TV screaming with the best of them.',
      description2: '',
      description3:  ''
    },
    // {
    //   id: 6,
    //   pId: 'p6',
    //   imgId: 'img6',
    //   textId: 'txt6',
    //   name: 'FLORIAN IHDE',
    //   role: 'Managing Director, DTIGmbH',
    //   linked: ' https://www.linkedin.com/in/florian-ihde-27572468/',
    //   email: 'fihde@drtobias.com',
    //   image: "url('./assets/images/team/florian1200x800.png')",
    //   isOpen: false,
    //   isLeft: false,
    //   description: 'Musical and red wine lover, caring father of two, husband and semi-professional athlete - that’s me in a nutshell! Table tennis is my passion as long as I can remember. I love the competition with other athletes and am dedicated to success. In my spare time, I enjoy exploring new restaurants with my family. On game days, I mutate to a passionate fan and support my favourite soccer team. Besides that, I enjoy traveling to all sort of places especially North America and Mexico. Tacos, Enchiladas and Churros - what a combo!',
    //   description2: '',
    //   description3:  ''
    // },
    {
      id: 6,
      pId: 'p6',
      imgId: 'img6',
      textId: 'txt6',
      name: 'ELIAS SAKKAL',
      role: 'Project Manager, DTI GmbH',
      linked: 'https://www.linkedin.com/in/e-sakkal2018/',
      email: ' esakkal@drtobias.com',
      image: "url('./assets/images/team/axel1200x800.png')",
      isOpen: false,
      isLeft: false,
      description: 'Born in Germany, Hamburg is my hometown. Raised close to the second biggest river in Germany, the famous harbour and river activities play a huge role in my life. Usually during summer, you can see me in my free time swimming, surfing or doing other kinds of water sport activities. I love to explore all sort of new cultures and countries from all over the world and try traditional dishes. Or typical dishes. Or dishes in general. Besides cheese – that’s my personal kryptonite, I’m a coffee lover, so I’m always happy when I get a good cup of hot coffee. Since Hamburg is my home, I frequently enjoy going to one of the many available concerts, musicals or just grabbing a bike and enjoying the beautiful city!',
      description2: '',
      description3:  ''
    },
    {
      id: 7,
      pId: 'p7',
      imgId: 'img7',
      textId: 'txt7',
      name: 'TERRI WYLIE',
      role: 'Customer Service Representative',
      linked: 'https://www.linkedin.com/in/terri-wyllie-2a637b2a/',
      email: ' twylie@mimisrock.com',
      image: "url('./assets/images/team/terri1200x800.png')",
      isOpen: false,
      isLeft: true,
      description: "I love learning new things with passion and also winning contests. I am a former IT professional who came back home to my Yoga practice that I loved and started with my mom while I was going to school. This led to teaching Yoga which has been a rewarding home-based business especially while I was raising my kids. Later, I took up Indian classical music and drumming in my 40" + "'" + "s and since that wasn't dangerous enough, I learned how to ride a motorcycle at 50 and got my licence. Did I mention contests? I won my car, a trip to Mexico, movies for a year and a nice ultralight laptop! I love to travel now, attend yoga retreats and swim with sea turtles. I love animals, and we have more pets than people in our home: a German Shepherd, a Cockatiel, 2 guinea pigs (both rescues) and an Old German Owl Pigeon.",
      description2: '',
      description3:  ''
    },
    {
      id: 8,
      pId: 'p8',
      imgId: 'img8',
      textId: 'txt8',
      name: 'LYNN MOFFAT',
      role: 'Customer Service Representative',
      linked: 'https://www.linkedin.com/in/lynnmoffatt/',
      email: 'lmoffatt@mimisrock.com',
      image: "url('./assets/images/team/lynn1200x800.png')",
      isOpen: false,
      isLeft: false,
      description: 'Born and raised on the edge of a small town along the Trans Canada Railway in Northern Ontario, I grew up surrounded by forest and imaginary friends.  To this day, I find solace in the sound of the wind blowing through the trees and the crisp northern air chilling my nostrils.  Music and nature are my drugs of choice.  There is nothing better than sitting on the side of a small lake, guitar in hand, watching the sunset.  Don’t get me wrong, I am addicted to the hustle and bustle of the city and love being immersed in new and exciting cultural experiences.  Now living in Downtown Toronto, I am grateful to share these experiences with real (non-imaginary) friends. It’s the balance of extremes that keeps life interesting.',
      description2: '',
      description3:  ''
    },
    {
      id: 9,
      pId: 'p9',
      imgId: 'img9',
      textId: 'txt9',
      name: 'MONICA RZEPECKI',
      role: 'Digital Content Specialist',
      linked: 'https://www.linkedin.com/in/monica-rzepecki/',
      email: 'mrzepecki@mimisrock.com',
      image: "url('./assets/images/team/monica1200x800.png')",
      isOpen: false,
      isLeft: true,
      description: "As a first-generation Canadian born in Toronto to Polish parents, I’m lucky to have grown up in a family that embraced both Canadian and Polish traditions. Picture Hockey Night in Canada with a side of pickles, kielbasa and perogies.",
      description2: "Prior to joining the Mimi’s Rock team, I worked at the City of Vaughan and a non-profit organization as a Marketing and Communications Coordinator.",
      description3:  "Fitness, technology and dogs are a few of my favourite things. With a passion for content creation and a keen eye for aesthetics, I’m thrilled to incorporate my interests and skills into my career."
    },
    {
      id: 10,
      pId: 'p10',
      imgId: 'img10',
      textId: 'txt10',
      name: 'ALYSSA HORNE',
      role: 'Director, Product Management & Operations',
      linked: 'https://www.linkedin.com/in/alyssahorne',
      email: 'ahorne@mimisrock.com',
      image: "url('./assets/images/team/alyssa1200x800.png')",
      isOpen: false,
      isLeft: false,
      description: "A born and bred east ender, I have lived my entire life in Toronto’s Durham Region. I take that back, I did venture out to London, Ontario for 5 years where I studied at the University of Western, Ontario. With a Double Major in Biology and Physiology and a post graduate certificate in pharmaceutical Regulatory Affairs, I naturally kick started my career off in Marketing – go figure. As much as I love what I do, my true passion in life is a full body, full glass of Californian Cabernet Sauvignon. Actually, I’m not picky, it doesn’t have to be from California! When not sipping a glass of my favourite red, I can be found at the cottage or local dog park with my husband and dog, Joey. Trust me, the two of them keep me quite busy. I’m excited to be on this journey at Mimi’s Rock and look forward to what the future has to hold.",
      description2: '',
      description3:  ''
    },
    {
      id: 11,
      pId: 'p11',
      imgId: 'img11',
      textId: 'txt11',
      name: 'Axel Linke',
      role: 'Accountant DTI GmbH',
      linked: 'https://www.linkedin.com/in/axel-linke-b43bba191',
      email: 'alinke@drtobias.com',
      image: "url('./assets/images/team/real-axel1200x800.png')",
      isOpen: false,
      isLeft: true,
      description: "Grown up in Hamburg in the turbulent and charming 60s & 70s, I appreciate the clear and understanding way of thinking in North Germany, with its typical dry (aged) humor that is nearly British-black.  No wonder, that I, as an adolescent, have devoured Anglo-Saxon literature (e.g. Roald Dahl, Douglas Adams, John Irving and John Steinbeck).",
      description2: "Nowadays, I like to devour an excellent Italian meal, too.  My longtime significant other from St. Petersburg and I enjoy searching and finding a special side dish to a delicate Scaloppine in our local forests: mushrooms (Porcini mushrooms and Chanterelles). Delicious!  Our ten-year-old grandchild is the most eager finder - no wonder, she is a Girl Guide!",
      description3: "In the forests you can find peaceful silence and relaxation, too. I learned that Germans and Russians have one thing in common - enjoying mushrooms!  Projected on my profession it would be my job to check at what location we were successful and whether our efforts have paid off. This can be a pleasurable task.  One of the most beautiful things in life is that humans can complement each other. It's great to be part of a single-minded and forward-thinking team."
    },
  ];

  @HostListener('window:resize', ['$event'])
  onResize() {

    if (window.innerWidth >= 720) {
      this.isMobile = false;
      this.startHeight = '400px';
      this.expandHeight = '750px';
      this.teamMembers.forEach((member) => {
        member.isOpen = false;
        $('#' + member.id).css('height', this.startHeight);
        $('#' + member.imgId).css({'min-width': '350px'});
        $('#' + member.imgId).css({'width': '25%'});
        $('#' + member.imgId).css({'height': '100%'});
        $('#' + member.imgId).css({'margin': '0'});
      });
    } else if (window.innerWidth >= 450 && window.innerWidth <= 719) {
      this.isMobile = true;
      this.startHeight = '300px';
      this.expandHeight = '550px';
      this.teamMembers.forEach((member) => {
        member.isOpen = false;
        $('#' + member.id).css('height', this.startHeight);
        $('#' + member.imgId).css({'min-width': '50%'});
        $('#' + member.imgId).css({'width': '25%'});
        $('#' + member.imgId).css({'height': '100%'});
        $('#' + member.imgId).css({'margin': '0'});
      });
    } else {
      this.isMobile = true;
      this.startHeight = '250px';
      this.expandHeight = '525px';
      this.teamMembers.forEach((member) => {
        member.isOpen = false;
        $('#' + member.id).css('height', this.startHeight);
        $('#' + member.imgId).css({'min-width': '50%'});
        $('#' + member.imgId).css({'width': '25%'});
        $('#' + member.imgId).css({'height': '100%'});
        $('#' + member.imgId).css({'margin': '0'});
      });
    }

  }

  constructor(public angulartics2: Angulartics2,
              private route: ActivatedRoute) {

  }

  ngOnInit() {
    this.route.fragment.subscribe(fragment => {
      this.fragment = fragment;
    });
    if (this.angulartics2) {
      this.angulartics2.eventTrack.next({
        action: 'page-view-team'
      });
      console.log(this.angulartics2);
    }
  }

  ngAfterViewInit(): void {
    try {
      if (this.fragment === 'title') {
        $('html,body').scrollTop(0);
      } else {
        $('html, body').animate({scrollTop: $('#' + this.fragment).offset().top}, {duration: 'medium'});
      }
    } catch (e) {
      // console.log(e);
    }
    if (window.innerWidth >= 720) {
      this.isMobile = false;
      this.startHeight = '400px';
      this.expandHeight = '750px';
    } else if (window.innerWidth >= 450 && window.innerWidth <= 719) {
      this.isMobile = true;
      this.startHeight = '300px';
      this.expandHeight = '550px';
    } else {
      this.isMobile = true;
      this.startHeight = '250px';
      this.expandHeight = '525px';
    }
    const teamImages = document.querySelectorAll('.image-container');
    for (let i = 0; i < teamImages.length; i++) {
      $(teamImages[i]).css('background-image', this.teamMembers[i].image);
    }
    if (window.innerWidth >= 1195) {
      $('#about-link').addClass('grey-text');
      $('#brands-link').addClass('grey-text');
      $('#team-link').addClass('grey-text');
      $('#investors-link').addClass('grey-text');
      $('#contact-link').addClass('grey-text');
    }

  }

  ngOnDestroy() {

  }

  gotoInvestors() {
    $('html, body').scrollTop(0);
    $('#under-bar').css({'opacity': 1});
    $('#under-bar').animate({'margin-left': '343px'});
    if (window.innerWidth <= 1194) {
      const mobileAbout = document.getElementById('mobile-about');
      mobileAbout.classList.remove('opac');
      const mobileBrands = document.getElementById('mobile-brands');
      mobileBrands.classList.remove('opac');
      const mobileTeam = document.getElementById('mobile-team');
      mobileTeam.classList.remove('opac');
      const mobileInvestors = document.getElementById('mobile-investors');
      mobileInvestors.classList.add('opac');
      const mobileContact = document.getElementById('mobile-contact');
      mobileContact.classList.remove('opac');
    }
  }

  openRow(id, pId, imgId, txtId) {
    if (this.teamMembers[id].isOpen === false) {
      this.teamMembers[id].isOpen = true;
      this.animateRow(id, pId, imgId, txtId);
    }
  }

  closeRow(id, pId, imgId, txtId, event) {
    this.teamMembers[id].isOpen = false;
    this.animateRow(id, pId, imgId, txtId);
    event.stopPropagation();
  }

  animateRow(id, pId, imgId, txtId) {

    const rowId = '#' + id;
    const imageId = '#' + imgId;
    const profileId = '#' + pId;
    const textId = '#'  + txtId;

    if (this.teamMembers[id].isOpen) {
      if (window.innerWidth <= 719 && window.innerWidth >= 450) {
        $(imageId).css('width', '45%');
        $(imageId).css({'min-width': '45%'});
        $(imageId).css({'height': '300px'});
        $(imageId).css({'margin': '2.5%'});
        $(rowId).animate({'height': this.expandHeight}, {duration: 'medium', complete: function() {
          $(profileId).animate({'opacity': 1}, {duration: 'slow'});
          $(textId).animate({'opacity': 1}, {duration: 'slow'});
        }});
      } else if (window.innerWidth <= 449) {
        $(imageId).css('width', '45%');
        $(imageId).css({'min-width': '45%'});
        $(imageId).css({'height': '250px'});
        $(imageId).css({'margin': '2.5%'});
        $(rowId).animate({'height': this.expandHeight}, {duration: 'medium', complete: function() {
          $(profileId).animate({'opacity': 1}, {duration: 'slow'});
          $(textId).animate({'opacity': 1}, {duration: 'slow'});
        }});
      } else {
        $(imageId).animate({'width': '45%'});
        $(rowId).animate({'height': this.expandHeight}, {duration: 'medium', complete: function() {
          $(profileId).animate({'opacity': 1}, {duration: 'slow'});
          $(textId).animate({'opacity': 1}, {duration: 'slow'});
        }});
      }
    } else {
      if (window.innerWidth <= 719) {
        $(imageId).css({'min-width': '50%'});
        $(imageId).css('width', '25%');
        $(imageId).css({'margin': '0'});
        $(rowId).animate({'height': this.startHeight}, {duration: 'medium', complete: function() {
          $(profileId).animate({'opacity': 0}, {duration: 'slow'});
          $(textId).animate({'opacity': 0}, {duration: 'slow'});
          $(imageId).css({'height': '100%'});
        }});
      } else {
        $(imageId).animate({'width': '25%'});
        $(rowId).animate({'height': this.startHeight}, {duration: 'medium', complete: function() {
          $(profileId).animate({'opacity': 0}, {duration: 'slow'});
          $(textId).animate({'opacity': 0}, {duration: 'slow'});
        }});
      }
    }
  }

}
